import { CognitoPermissionGroups } from 'core/helpers/cognito-permission-groups';

export const actions = [
  {
    id: 'Override Loan Number Validation',
    value: 'Override Loan Number Validation',
    permissionName: CognitoPermissionGroups.canOverrideLoanNumVal
  },
  {
    id: 'Allow Adding Water Backup',
    value: 'Allow Adding Water Backup',
    permissionName: CognitoPermissionGroups.canAllowWaterBackup
  },
  {
    id: 'Allow Rating With AUX Codes',
    value: 'Allow Rating With AUX Codes',
    permissionName: CognitoPermissionGroups.canAllowAuxRating
  },
  {
    id: 'Override Branded Title',
    value: 'Override Branded Title',
    permissionName: CognitoPermissionGroups.canOverrideBrandedTitle
  },
  {
    id: 'Override MSRP Too High',
    value: 'Override MSRP Too High',
    permissionName: CognitoPermissionGroups.canOverrideMSRP
  },
  {
    id: 'Override Excluded VIN',
    value: 'Override Excluded VIN',
    permissionName: CognitoPermissionGroups.canOverrideExcludedCar
  },
  {
    id: 'Override Replacement Cost Values',
    value: 'Override Replacement Cost Values',
    permissionName: CognitoPermissionGroups.toolsOverrideReplacementCost,
    warning:
      'Once the tool returns the new offer, any modifications to the home characteristics and coverages will override the changes done in this tool. It is expected that the offer returned will be bound with minimal to no updates.'
  }
];
